import produce from 'immer'
import { QuestionStepSchema } from '@feedyou/schema'

import { GetUsedDialogs } from '../../../types'

export const getUsedDialogs: GetUsedDialogs<QuestionStepSchema> = (
  { answers = [], disabled, defaultAnswer },
  enabledOnly = false
) => {
  if (enabledOnly && disabled) {
    return []
  }

  return produce([] as string[], result => {
    answers?.forEach(answer => {
      if (answer.dialog && Boolean(!enabledOnly || !answer.disabled)) {
        result.push(answer.dialog)
      }
    })

    if (defaultAnswer?.dialog && Boolean(!enabledOnly || !defaultAnswer.disabled)) {
      result.push(defaultAnswer?.dialog)
    }
  })
}
